import { type Virtualizer } from '@tanstack/react-virtual'

export type IScrollAnchor = {
  index: number
  offset: number
}

type IResolveScrollAnchorParams = {
  virtualizer: Virtualizer<HTMLDivElement, Element> | null
  scrollElement: HTMLElement | null
  prevKeys: Array<string | number>
  nextKeys: Array<string | number>
}

export const resolveScrollAnchor = ({
  virtualizer,
  scrollElement,
  prevKeys,
  nextKeys,
}: IResolveScrollAnchorParams): IScrollAnchor | null => {
  const scrollOffset = scrollElement?.scrollTop

  if (!virtualizer || scrollOffset === undefined) return null

  const firstVisible = virtualizer.getVirtualItemForOffset(scrollOffset)

  if (!firstVisible) return null

  const nextIndexes = new Map(nextKeys.map((key, index) => [key, index]))

  for (let index = firstVisible.index; index < prevKeys.length; index++) {
    const key = prevKeys[index]
    const nextIndex = nextIndexes.get(key)

    if (nextIndex === undefined) continue
    if (nextKeys[nextIndex + 1] !== prevKeys[index + 1]) continue

    const item = virtualizer.measurementsCache[index]

    return item ? { index: nextIndex, offset: scrollOffset - item.start } : null
  }

  return null
}
